import { FC } from 'react'
import { Label } from '@cargomart/ui'
import { compose, FieldFormItem, maxChar, minMax, required, trimRequired } from 'forms'
import FieldCargoSize from 'forms/FieldCargoSize'
import { formatPrice } from 'helpers/common'
import { FieldNumber, FieldText } from 'shared/forms'

import { MAX_ABOUT, MAX_PRICE, MAX_PRICE_GRADE, MIN_PRICE } from './OrderGuestCreateForm/constants'

const OrderCargoSize: FC = () => {
  const fieldClassName = 'w-full'

  return (
    <>
      <FieldFormItem name="cargo.sizeId">
        <FieldCargoSize name="cargo.sizeId" validate={required} />
      </FieldFormItem>
      <FieldFormItem label={<Label className="pt-2">Объявленная ценность</Label>} name="cargo.price">
        <FieldNumber
          className="[&>*:first-child] + &>*:!text-on-surface w-full"
          max={MAX_PRICE_GRADE}
          name="cargo.price"
          prefix="₽"
          scale={2}
          validate={compose(required, minMax(MIN_PRICE, MAX_PRICE, '₽', formatPrice))}
        />
      </FieldFormItem>
      <FieldFormItem
        className={fieldClassName}
        label={<Label className="pt-2">Описание груза</Label>}
        name="cargo.about"
      >
        <FieldText className={fieldClassName} name="cargo.about" validate={compose(trimRequired, maxChar(MAX_ABOUT))} />
      </FieldFormItem>
    </>
  )
}

export default OrderCargoSize
